class PlayVideo {
    constructor() {
        this.loadmoreElm    = document.querySelector('.video-load-more-btn');
        this.hiddenFormElm  = document.querySelector('.hidden_form');
        this.pagedElm       = this.hiddenFormElm.querySelector('.paged');
        this.ppr            = this.hiddenFormElm.querySelector('.ppr');
        this.events();
    }

    filterAjax() {
        var pagedElm           = this.pagedElm;
        var loadmoreELm        = this.loadmoreElm;
        const request          = new XMLHttpRequest();
        let data               = `action=videoLibraryLoadMore&paged=${pagedElm.value}&ppr=${this.ppr.value}`;
        request.open('POST', orr_ajax_object.ajaxurl, true);
        request.setRequestHeader(
          'Content-Type',
          'application/x-www-form-urlencoded; charset=UTF-8'
        );
        request.onload = function () {
          if (this.status >= 200 && this.status < 400) {
            var content = JSON.parse(this.response);
              document.querySelector('.video-library-archive__wrapper .row').insertAdjacentHTML('beforeend', content.content);
              if( localStorage.getItem("email") )
              {
                const popUpFormBtn = document.querySelectorAll('[data-bs-target="#videoFormModal"]');
                [...popUpFormBtn].forEach(btn => {
                    btn.remove();
                });

                const el2 = document.querySelectorAll('.card-video-btn');
                if (el2) {
                    for (var i = 0; i < el2.length; i++) {
                        el2[i].addEventListener('click', 
                        (e) => {
                            // const source = this.parentElement.querySelector('.card-video__video-iframe').src;
                            const videoTag = e.target.getAttribute('data-tag');
                            const videoDate = e.target.getAttribute('data-date');
                            const videoTitle = e.target.getAttribute('data-title');
                            const videoContent = e.target.getAttribute('data-desc');
                            const videoPermalink  = e.target.getAttribute('data-permalink');
                            const videoUrl     = e.target.getAttribute('data-video-url');

                             document.querySelector('.card-video__content-popup').innerHTML = `
                                <div class="d-none card-video__info d-flex flex-wrap text-primary ps-0 mb-0 body-2">
                                <span><a href="${videoPermalink}">${videoTag}</a></span>
                                <span><a href="${videoPermalink}">${videoDate}</a></span>
                            </div>
                            <h6 class="h7 text-orr-blue d-block mb-2 mt-1 mb-md-3 mt-md-2 mb-xl-6"><a href="${videoPermalink}">${videoTitle}</a></h6>
                            <p>${videoContent}</p>`;
                            document.querySelector('.modal-video__iframe').src = videoUrl;
                        });
                    }
                }
              }
              else
              {

                const el3 = document.querySelectorAll('.card-video-form-popup');
                if (el3) {
                    for (var i = 0; i < el3.length; i++) {
                        el3[i].addEventListener('click', 
                        (e) => {
                            const videoTag = e.target.getAttribute('data-tag');
                            const videoDate = e.target.getAttribute('data-date');
                            const videoTitle = e.target.getAttribute('data-title');
                            const videoContent = e.target.getAttribute('data-desc');
                            const videoUrl     = e.target.getAttribute('data-video-url');
                            const videoPermalink  = e.target.getAttribute('data-permalink');
                            document.querySelector('.card-video-gated-content').innerHTML = `
                            <div class="d-none card-video__info d-flex flex-wrap text-primary ps-0 mb-0 body-2">
                            <span><a href="javascript:void()">${videoTag}</a></span>
                            <span><a href="javascript:void(0)">${videoDate}</a></span>
                            </div>
                            <h6 class="h7 text-orr-blue d-block mb-2 mt-1 mb-md-3 mt-md-2 mb-xl-6">${videoTitle} </h6>
                            <p>${videoContent}</p>`;
                    
                            document.querySelector('.card-video__content-popup').innerHTML = `
                                <div class="d-none card-video__info d-flex flex-wrap text-primary ps-0 mb-0 body-2">
                                <span><a href="${videoPermalink}">${videoTag}</a></span>
                                <span><a href="${videoPermalink}">${videoDate}</a></span>
                            </div>
                            <h6 class="h7 text-orr-blue d-block mb-2 mt-1 mb-md-3 mt-md-2 mb-xl-6"><a href="${videoPermalink}">${videoTitle}</a></h6>
                            <p>${videoContent}</p>`;
                            document.querySelector('.modal-video__iframe').src = videoUrl;

                        });
                    }
                }

              }
              if (pagedElm.value >= content.maxNumPages || content.foundPosts == 0)
                loadmoreELm.classList.add('d-none');
            else loadmoreELm.classList.remove('d-none');
          } else {
            console.log(this.status);
          }
        };
        request.onerror = function () {
          // Connection error
          console.log('error');
        };
        request.send(data);
      }
    
    videoPlay() {
        const el = document.querySelectorAll('.card-video__video-play');
        if (el) {
            for (var i = 0; i < el.length; i++) {
                el[i].addEventListener('click', this.hideContent);
            }
        }
        const el2 = document.querySelectorAll('.card-video-btn');
        if (el2) {
            for (var i = 0; i < el2.length; i++) {
                el2[i].addEventListener('click', this.playModalVideo);
            }
        }
        const el3 = document.querySelectorAll('.card-video-form-popup');
        if (el3) {
            for (var i = 0; i < el3.length; i++) {
                el3[i].addEventListener('click', this.GatedVideoFormPopup);
            }
        }
    }

    videoModulePlay() {
        const el1 = document.querySelectorAll('.video-module__video-poster-play');
        if (el1) {
            for (var i = 0; i < el1.length; i++) {
                el1[i].addEventListener('click', this.hideContent);
            }
        }
    }

    hideContent() {
        this.parentElement.style.display = 'none';
        this.parentElement.nextElementSibling.src += "?autoplay=1";
        this.parentElement.nextElementSibling.setAttribute('allow', 'autoplay');
    }
    
    playModalVideo() {
        const source = this.parentElement.querySelector('.card-video__video-iframe').src;
        const videoTag = this.getAttribute('data-tag');
        const videoDate = this.getAttribute('data-date');
        const videoTitle = this.getAttribute('data-title');
        const videoContent = this.getAttribute('data-desc');
        const videoPermalink  = this.getAttribute('data-permalink');

        document.querySelector('.card-video__content-popup').innerHTML = `
        <div class="d-none card-video__info d-flex flex-wrap text-primary ps-0 mb-0 body-2">
        <span><a href="${videoPermalink}">${videoTag}</a></span>
        <span><a href="${videoPermalink}">${videoDate}</a></span>
    </div>
    <h6 class="h7 text-orr-blue d-block mb-2 mt-1 mb-md-3 mt-md-2 mb-xl-6"><a href="${videoPermalink}">${videoTitle}</a></h6>
    <p>${videoContent}</p>`;
        const queryString = source;
        var url = new URL(queryString);
        var c = url.searchParams.get("autoplay");
        if( c == null)
        {
            document.querySelector('.modal-video__iframe').src = source+"?autoplay=1";
        }
        else
        {
            document.querySelector('.modal-video__iframe').src = source;
        }
        document.querySelector('.modal-video__iframe').setAttribute('allow', 'autoplay');
    }

    validateEmail = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    submitPopupForm = () => {
        const videoFormBtn = document.querySelector('.video-form-btn');
        if (videoFormBtn) {
            videoFormBtn.addEventListener('click', () => {
                // event.preventDefault();
                const email = document.querySelector('.modal-video-form [name="email"]').value;
                if (this.validateEmail(email)) {
                    this.setFormValLocalStorage(email);
                    $("#videoFormModal").modal('hide');
                    this.hideForm();
                    $('#videoModal').modal('show');

                    const source = document.querySelector('.modal-video__iframe').src;
                    var url = new URL(queryString);
                    var c = url.searchParams.get("autoplay");
                    if( c == null)
                    {
                        document.querySelector('.modal-video__iframe').src = source+"?autoplay=1";
                    }
                    document.querySelector('.modal-video__iframe').setAttribute('allow', 'autoplay');   
                }
            });
        }
    }

    hideForm = () => {
        if (this.getFormValLocalStorage()) {
            const popUpFormBtn = document.querySelectorAll('[data-bs-target="#videoFormModal"]');
            [...popUpFormBtn].forEach(btn => {
                btn.remove();
            });
        }
    }

    setFormValLocalStorage(value) {
        localStorage.setItem("email", value);
    }

    getFormValLocalStorage() {
        return localStorage.getItem("email");
    }

    GatedVideoFormPopup() {
        const videoTag = this.getAttribute('data-tag');
        const videoDate = this.getAttribute('data-date');
        const videoTitle = this.getAttribute('data-title');
        const videoContent = this.getAttribute('data-desc');
        const videoUrl     = this.getAttribute('data-video-url');
        const videoPermalink  = this.getAttribute('data-permalink');
        document.querySelector('.card-video-gated-content').innerHTML = `
        <div class="d-none card-video__info d-flex flex-wrap text-primary ps-0 mb-0 body-2">
        <span><a href="javascript:void()">${videoTag}</a></span>
        <span><a href="javascript:void(0)">${videoDate}</a></span>
        </div>
        <h6 class="h7 text-orr-blue d-block mb-2 mt-1 mb-md-3 mt-md-2 mb-xl-6">${videoTitle} </h6>
        <p>${videoContent}</p>`;

        document.querySelector('.card-video__content-popup').innerHTML = `
            <div class="d-none card-video__info d-flex flex-wrap text-primary ps-0 mb-0 body-2">
            <span><a href="${videoPermalink}">${videoTag}</a></span>
            <span><a href="${videoPermalink}">${videoDate}</a></span>
        </div>
        <h6 class="h7 text-orr-blue d-block mb-2 mt-1 mb-md-3 mt-md-2 mb-xl-6"><a href="${videoPermalink}">${videoTitle}</a></h6>
        <p>${videoContent}</p>`;
        document.querySelector('.modal-video__iframe').src = videoUrl;
    }

    loadmoreVideo()
    {
        this.loadmoreElm.addEventListener('click', (e) => {
            e.preventDefault();
            this.pagedElm.value = +this.pagedElm.value + 1;
            this.pagedElm.setAttribute('value', this.pagedElm.value);
            this.filterAjax();
          });
          
    }

    closeTeamModal(){
        $('#videoModal').on('hidden.bs.modal', function (e) {
            var removeAutoplay = document.querySelector('.modal-video__iframe').src.replace('?autoplay','');
            document.querySelector('.modal-video__iframe').src = '';
            return false;
        });
    }

    removeAutoPlayIframe()
    {
        const iframeElm = document.querySelectorAll('iframe');
        if (iframeElm) {
            for (var i = 0; i < iframeElm.length; i++) {
                let url    = new URL( iframeElm[i].src );
                let params = new URLSearchParams(url.search);
                // Delete the foo parameter.
                params.delete('autoplay');
                url.search = params.toString();
                var new_url = url.toString();
                iframeElm[i].setAttribute('src', new_url );
            }
        }
    }

    events()
    {
        this.videoPlay();
        this.videoModulePlay();
        this.submitPopupForm();
        this.loadmoreVideo();
        this.closeTeamModal();
        this.removeAutoPlayIframe();
        this.hideForm();
    }
}

export default PlayVideo;
new PlayVideo();
